import styled from "styled-components";

export const SectionContainer = styled.div`
  padding: 4rem 0;
`;

export const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: 2rem;
  font-weight: bold;
`;
